<template>
    <div v-if="user" class="box">
        <span class="username">{{ user.userName }}</span>
        <el-image :src="user.headPic" class="avatar"></el-image>
    </div>
</template>

<script>
export default {
    props: ['user'],
    data() {
        return {

        }
    }
}
</script>

<style scoped>

.box{
    display: flex;
    text-align: top;
}
.username {
    font-size: small;
    margin-right: 10px;
    line-height: 30px;
}

.avatar {
    width: 30px;
    height: 30px;
    border-radius: 15px;
}
</style>